import React, { Component, Fragment } from 'react';
import { Table, Jumbotron, Row, Col, Button, Form } from 'react-bootstrap';
// ;
import config from '../../config';

export class ReporteSalto extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;
        this.state = {
            info: [],
            fecha_ini: todayFormat,
            fecha_fin: todayFormat,
            currentCompany,
            empresa: currentCompany
        }
    }

    updateReport = () => {
        const { fecha_ini, fecha_fin, empresa } = this.state;
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                fecha_ini,
                fecha_fin,
                empresa
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        }
        fetch(config.servBackEnd + '/reports/sequentialjumpreport', datasend)
            .then(res => res.json())
            .then((data) => {
                if (data.ok) {
                    const info = data.data[0];
                    this.setState({ info })
                } else {
                    this.setState({ info: [] })
                }
            })
            .catch((error) => console.error(error))
    }

    render() {
        const { info } = this.state;
        return (
            <Fragment>

                <Jumbotron className="Jumbotron">Reporte estado empresas</Jumbotron>
                <Row>
                    <Col>
                        NIT <Form.Control type="text" onChange={(e) => this.setState({ empresa: e.target.value })} value={this.state.empresa} disabled={this.state.currentCompany !== '111111111'} />
                    </Col>
                    <Col>
                        Fecha Inicial <Form.Control type="date" onChange={(e) => this.setState({ fecha_ini: e.target.value })} value={this.state.fecha_ini} />
                    </Col>
                    <Col>
                        Fecha Final <Form.Control type="date" onChange={(e) => this.setState({ fecha_fin: e.target.value })} value={this.state.fecha_fin} />
                    </Col>
                    <Col>
                        <Button variant="primary" className="m-3" onClick={this.updateReport} >Genera Informe</Button>
                    </Col>
                </Row>
                <Table className="tableFixHead">
                    <thead>
                        <tr>
                            <th>NIT</th>
                            <th>PREFIJO DIAN</th>
                            <th>FECHA</th>
                            <th>PRIMER DOCUMENTO</th>
                            <th>ULTIMO DOCUMENTO</th>
                            <th>CANTIDAD ESPERADA</th>
                            <th>CANTIDAD REAL</th>
                            <th>DIFERENCIA</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            info.map((element, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{element.ID_EMPRESA}</td>
                                        <td>{element.PREFIJO_DIAN}</td>
                                        <td>{element.FECHA_DOCUMENTO}</td>
                                        <td>{element.PRIMER_DOCUMENTO}</td>
                                        <td>{element.ULTIMO_DOCUMENTO}</td>
                                        <td>{element.CANTIDAD_ESPERADA}</td>
                                        <td>{element.CANTIDAD_REAL}</td>
                                        <td>{element.CANTIDAD_ESPERADA - element.CANTIDAD_REAL}</td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </Table>
            </Fragment>
        )
    }
}

export default ReporteSalto



// WEBPACK FOOTER //
// ./src/components/reportes/reporteSalto.jsx